import { createGlobalStyle, css } from "styled-components"
import { Theme } from "theme"

import NBInternationalLightWoff from "./fonts/NBInternationalLight.woff"
import NBInternationalLightWoff2 from "./fonts/NBInternationalLight.woff2"

import NBInternationalBoldWoff from "./fonts/NBInternationalBold.woff"
import NBInternationalBoldWoff2 from "./fonts/NBInternationalBold.woff2"

import NBInternationalMonoTTF from "./fonts/NBInternationalMono.ttf"

import CheltenhamStdEOT from "./fonts/CheltenhamStd.eot"
import CheltenhamStdWoff from "./fonts/CheltenhamStd.woff"
import CheltenhamStdWoff2 from "./fonts/CheltenhamStd.woff2"

import NBInternationalItalicOtf from "./fonts/NBInternationalItalic.otf"

export const UNDERLINE_TEXT_CSS = css`
  border-bottom: 2px solid;
`

export const REMOVE_UNDERLINE_TEXT_CSS = css`
  border-bottom: none;
`

export const GlobalStyles = createGlobalStyle<{ theme: Theme }>`
  @font-face {
    font-family: 'CheltenhamStd';
    src: url(${CheltenhamStdEOT}) format("embedded-opentype"), url(${CheltenhamStdWoff}) format("woff"), url(${CheltenhamStdWoff2}) format("woff2");
    font-weight: normal;
    font-style: normal;
    font-display: fallback;
  }

  @font-face {
    font-family: 'NBInternational';
    src: url(${NBInternationalBoldWoff}) format("woff"), url(${NBInternationalBoldWoff2}) format("woff2");
    font-weight: bold;
    font-style: normal;
    font-display: fallback;
  }

  @font-face {
    font-family: 'NBInternational';
    src: url(${NBInternationalItalicOtf}) format("opentype");
    font-weight: normal;
    font-style: italic;
    font-display: fallback;
  }

  @font-face {
    font-family: 'NBInternational';
    src: url(${NBInternationalLightWoff}) format("woff"), url(${NBInternationalLightWoff2}) format("woff2");
    font-weight: lighter;
    font-style: normal;
    font-display: fallback;
  }

  @font-face {
    font-family: 'NBInternational-Mono';
    src: url(${NBInternationalMonoTTF}) format("truetype");
    font-weight: normal;
    font-style: normal;
    font-display: fallback;
  }

	h1,h2,h3,h4,h5,h6,p {
		padding: 0;
		margin: 0;
	}

	ul, li {
		margin: 0;
		padding: 0;
		list-style-type: none;
	}

  html {
    max-width: 100%;
    overflow-x: hidden;
  }

	body {
    overflow-x: hidden;
		margin: 0;
    color: ${props => props.theme.colors.evergreen};
    min-width: 375px; /* We lock at 375 min and zoom viewport to fit for smaller devices */
	}

  b, strong {
    font-weight: 700;
  }

  a {
    color: inherit;
  }

	video, img {
		width: 100%;
		height: auto;

    /* This is a fallback for some browsers (e.g. Safari). See for reference https://caniuse.com/#feat=intrinsic-width */
    height: intrinsic;
	}

  fieldset {
    border: 0;
    padding: 0;
    margin: 0;
    min-width: 0;
  }

  button {
    border: none;
    margin: 0;
    padding: 0;
    width: auto;
    overflow: visible;

    background: transparent;
    cursor: pointer;
    user-select: none;
    font: inherit;
    line-height: normal;

    :focus {
      outline-color: ${props => props.theme.colors.melrose}
    }
  }

  input, textarea {
    border: none;
    background-color: transparent;

    :focus {
      outline-color: ${props => props.theme.colors.melrose}
    }

    :disabled {
      background-color: transparent;
    }
  }

  input[type="number"] {
    /* Disable browser number controls */
    -moz-appearance: textfield;
    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }

	* {
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
  }

  @media (prefers-reduced-motion: reduce) {
    * {
      transition: none !important;
      animation: none !important;
    }
  }

  /* React Tooltip styles */
  .tooltop-text {
    pointer-events: auto !important;
    &:hover {
    visibility: visible !important;
    opacity: 1 !important;
  }
`

export * from "./react-widgets"
